export const displayChangePlanButtonText = (
  isSelected: boolean,
  isChosenPlan?: boolean
) => {
  if ((isSelected && isChosenPlan) || (!isSelected && !isChosenPlan)) {
    return "common:billing.subscriptionStep.planChange.yourPlan";
  }

  if (isSelected && !isChosenPlan) {
    return "billing.subscriptionStep.planChange.selected";
  }

  return "billing.subscriptionStep.planChange.choose";
};
